import React from 'react';
import S from './TopLinkList.styles';
const TopLinkList = ({ items = [] }) => {
    return (React.createElement(S.Container, null, items.map((item) => (React.createElement(S.Link, { key: item.id, href: item.url }, item.text)))));
};
export default TopLinkList;
